module.exports = __webpack_public_path__ + "static/media/soham_laghate.e17a99eb.png";